import {
    englishFirstNames, englishLastNames,
    frenchFirstNames, frenchLastNames,
    turkishFirstNames, turkishLastNames,
    spanishFirstNames, spanishLastNames,
    germanFirstNames, germanLastNames,
    portugueseFirstNames, portugueseLastNames,
    arabicFirstNames, arabicLastNames,
    hindiFirstNames, hindiLastNames,
    japaneseFirstNames, japaneseLastNames,
    koreanFirstNames, koreanLastNames,
    indonesianFirstNames, indonesianLastNames,
    vietnameseFirstNames, vietnameseLastNames,
    russianFirstNames, russianLastNames,
    italianFirstNames, italianLastNames,
    polishFirstNames, polishLastNames,
    dutchFirstNames, dutchLastNames,
} from '@/constants/wildWestNames';

export interface WildWestNameGeneratorOptions {
    count?: number;
    language?: 'en' | 'fr' | 'tr' | 'es' | 'de' | 'pt' | 'ar' | 'hi' | 'ja' | 'ko' | 'id' | 'vi' | 'ru' | 'it' | 'pl' | 'nl';
}

const nameMap: Record<string, { firstNames: string[]; lastNames: string[] }> = {
    en: { firstNames: englishFirstNames, lastNames: englishLastNames },
    fr: { firstNames: frenchFirstNames, lastNames: frenchLastNames },
    tr: { firstNames: turkishFirstNames, lastNames: turkishLastNames },
    es: { firstNames: spanishFirstNames, lastNames: spanishLastNames },
    de: { firstNames: germanFirstNames, lastNames: germanLastNames },
    pt: { firstNames: portugueseFirstNames, lastNames: portugueseLastNames },
    ar: { firstNames: arabicFirstNames, lastNames: arabicLastNames },
    hi: { firstNames: hindiFirstNames, lastNames: hindiLastNames },
    ja: { firstNames: japaneseFirstNames, lastNames: japaneseLastNames },
    ko: { firstNames: koreanFirstNames, lastNames: koreanLastNames },
    id: { firstNames: indonesianFirstNames, lastNames: indonesianLastNames },
    vi: { firstNames: vietnameseFirstNames, lastNames: vietnameseLastNames },
    ru: { firstNames: russianFirstNames, lastNames: russianLastNames },
    it: { firstNames: italianFirstNames, lastNames: italianLastNames },
    pl: { firstNames: polishFirstNames, lastNames: polishLastNames },
    nl: { firstNames: dutchFirstNames, lastNames: dutchLastNames },
};

export function generateWildWestNames(options: WildWestNameGeneratorOptions = {}): string[] {
    const count = options.count || 10;
    const language = options.language || 'en';
    const names: string[] = [];

    const { firstNames, lastNames } = nameMap[language] || nameMap['en'];

    for (let i = 0; i < count; i++) {
        const firstName = firstNames[Math.floor(Math.random() * firstNames.length)];
        const lastName = lastNames[Math.floor(Math.random() * lastNames.length)];
        names.push(`${firstName} ${lastName}`);
    }

    return names;
}
